import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './newOrder.actions.js';
import getters from './newOrder.getters.js';
import mutations from './newOrder.mutations.js';
import initialState from './newOrder.state.js';

BaseStore.registerModule('newOrder', {
	namespaced: true,
	state: initialState,
	mutations,
	actions,
	getters
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('newOrder');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
